import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './sxIcon.scss';

class SxIcon extends Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    const { onClick: click } = this.props;
    if (click) {
      click(event);
    }
  }

  render() {
    const { className, color, float, fontSize, name, noFloat, children = null } = this.props;
    let alignClass = '';
    if (!noFloat) {
      alignClass = cx({ [`sx-${float}`]: float }, { 'sx-left': !float });
    }
    const style = {
      color,
      fontSize,
    };
    return (
      <i onClick={this.onClick} style={style} className={`sx-icon ${alignClass} ${name} ${className || ''}`}>
        {children}
      </i>
    );
  }
}

SxIcon.propTypes = {
  name: PropTypes.string.isRequired,
  float: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default SxIcon;
